import {NoteEditorState} from './components/note-editor/types';

export class AnswerState {
	constructor(
		public selected: boolean = false,
		public note: NoteEditorState = new NoteEditorState(),
	) {}
}
